export const VIEWS = {
  TABLE: 'Table',
  CHART: 'Chart',
} as const;

export const Constants = {
  TAG_NAME: 'pop-sector-diversification-component',
  COMPONENT_TITLE: 'Sector diversification',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'data-as-of-select',
  VIEW_DROPDOWN_LABEL: 'View',
  VIEW_DROPDOWN_ID: 'view-select',
  VIEWS: [VIEWS.TABLE, VIEWS.CHART],
  DEFAULT_VIEW: VIEWS.CHART,
  BENCHMARK_PREFIX: 'Benchmark:',
  NO_TABLE_DATA_AVAILABLE: 'Sector diversification table unavailable',
  NO_CHART_DATA_AVAILABLE: 'Sector diversification chart unavailable',
} as const;
